var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('Btn',_vm._g(_vm._b({staticClass:"btn-special-build",attrs:{"color":"orange","large":_vm.large,"icon":""},on:{"click":function($event){return _vm.$emit('click',$event)}}},'Btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-star")])],1)]}}])},'v-tooltip',_vm.$attrs,false),[_c('div',[_vm._v(" Special Build ")])])}
var staticRenderFns = []

export { render, staticRenderFns }